import React, { useState, useEffect } from "react";
import './style.scss';
import { Layout, Card, Row, Col, Statistic, Select, Typography, Tooltip } from 'antd';
import AuthService from '../../services/AuthService';
import DashboardService from '../../services/DashboardService';
import { LoadingOutlined } from "@ant-design/icons";
import R2Footer from "../../components/Footer";
import { useSelector } from "react-redux";


const { Title, Text } = Typography;

const { Option } = Select
const { Content } = Layout;
const { Meta } = Card;

const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [dashboard, setDashboard] = useState({});
    const [kpi, setKpi] = useState();
    const [selectedKpi, setSelectedKpi] = useState("Today");
    const [revenueDate, setRevenueDate] = useState();
    const [salesDate, setSalesDate] = useState();
    const [revenueItem, setRevenueItem] = useState();
    const [salesItem, setSalesItem] = useState();
    const adminRestaurant = useSelector((state) => state.admin)

    useEffect(() => {
        getDashboard();
        // return () => {
        //     cleanup
        // }
    }, [adminRestaurant])


    const getDashboard = async () => {
        const user = await AuthService.getLoggedInUser();
        const restaurants = await DashboardService.getRestaurantsByUser();
        const kpis = await DashboardService.getKpi(adminRestaurant);
        if(kpis)
        {
            setSalesDate(kpis.sales.today)
            setRevenueDate(kpis.revenue.today)
            setRevenueItem(kpis?.topItems?.revenue?.today)
            setSalesItem(kpis?.topItems?.sales?.today)
            setKpi(kpis)
        }
       
        setDashboard({ ...dashboard, user, restaurants });
    }

    function handleChange(value) {
        switch (value) {
            case "Today":
                setSalesDate(kpi.sales.today)
                setRevenueDate(kpi.revenue.today)
                setRevenueItem(kpi.topItems.revenue.today)
                setSalesItem(kpi.topItems.sales.today)
                break;
            case "Week":
                setSalesDate(kpi.sales.week)
                setRevenueDate(kpi.revenue.week)
                setRevenueItem(kpi.topItems.revenue.week)
                setSalesItem(kpi.topItems.sales.week)
                break;
            case "Month":
                setSalesDate(kpi.sales.month)
                setRevenueDate(kpi.revenue.month)
                setRevenueItem(kpi.topItems.revenue.month)
                setSalesItem(kpi.topItems.sales.month)
                break;
            default:
                setSalesDate(kpi.sales.today)
                setRevenueDate(kpi.revenue.today)
                setRevenueItem(kpi.topItems.revenue.today)
                setSalesItem(kpi.topItems.sales.today)
                break;
        }
    }

    const getGreeting = () => {
        const hrs = (new Date()).getHours();

        if (hrs < 12) {
            return 'Good Morning';
        } else if (hrs >= 12 && hrs <= 17) {
            return 'Good Afternoon';
        } else {
            return 'Good Evening';
        }
    }

    const position = [51.505, -0.09]
    return (
        <Layout style={{ padding: '0 24px 24px' }}>
            <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: '16px 0px',
                    textAlign: 'left'
                }}
            >
                {
                    loading ?
                        <LoadingOutlined />
                        :
                        <div>
                            <h2>{getGreeting()} {dashboard.user?.split(' ')[0]}!</h2>
                            <hr />
                            <Card title="Restaurants" className="kpi-card">
                                <Row gutter={[16, 48]}>



                                    {
                                        dashboard.restaurants && dashboard.restaurants.length > 0 &&
                                        dashboard.restaurants.map(restaurant =>

                                            <Col key={restaurant.id}>
                                                <Card title={restaurant.name} className="restaurent-card">
                                                    <p>{restaurant.address}</p>
                                                    <p>{restaurant.phone}</p>
                                                    <div className="settings-heading">Restaurent Settings</div>
                                                    <Tooltip title="This will be the minimum quantity that a user will have to order for a regular menu item" color={"#108ee9"}>
                                                     <div className="tooltip-text">Minimum Order Quantity for a regular order : {restaurant.min_order_quantity}</div>
                                                    </Tooltip>
                                                    <Tooltip title="This will be the maximum quantity that a user will have to order for a regular menu item. Ordering beyond this quantity will be considered as a catering order" color={"#108ee9"}>
                                                     <div className="tooltip-text">Maximum Order quantity for a regular order  : {restaurant.max_order_quantity}</div>
                                                    </Tooltip>
                                                    <Tooltip title="This will be the Expected Time of Arrival (ETA) that will be used to process Pickup orders" color={"#108ee9"}>
                                                     <div className="tooltip-text">Pickup order turnaround time : {restaurant.eta_pickup_order}Minutes</div>
                                                    </Tooltip>
                                                    <Tooltip title="This will be the Expected Time of Arrival (ETA) that will be used to process Pickup orders" color={"#108ee9"}>
                                                     <div className="tooltip-text">Delivery order turnaround time : {restaurant.eta_delivery_order}Minutes</div>
                                                    </Tooltip>
                                                </Card>
                                            </Col>



                                        )}


                                </Row>
                            </Card>

                            <div className="select-section">
                                <Select defaultValue="Today" style={{ width: 200 }} onChange={handleChange}>
                                    <Option value="Today">Today</Option>
                                    <Option value="Week">Week</Option>

                                    <Option value="Month">Month</Option>
                                </Select>
                            </div>


                            {kpi && kpi.revenue &&

                                <Row gutter={[16, 48]} className="kpi-content-container">
                                    <Col span={12}>
                                        <Card title="Revenue" className="kpi-card revenue-card">


                                            <Card>
                                                <Statistic title={selectedKpi} prefix="$" value={revenueDate} precision={0} />
                                            </Card>

                                        </Card>
                                    </Col>

                                    <Col span={12}>
                                        <Card title="Sales" className="kpi-card sales-card">


                                            <Card>
                                                <Statistic title={selectedKpi} prefix="$" value={salesDate} precision={0} />
                                            </Card>

                                        </Card>
                                    </Col>

                                </Row>

                            }

                            {kpi && kpi.topItems &&
                                <Row gutter={[16, 48]} className="kpi-content-container">
                                    <Col span={12}>
                                        {revenueItem && revenueItem.length > 0 &&
                                            <Card title="Top Items based on Revenue" className="kpi-card revenue-card">


                                                <Row gutter={[16, 48]}>
                                                    {revenueItem.map(item =>
                                                        <Col >


                                                            <Card
                                                                hoverable
                                                                style={{ height: "100%", width: 600, maxWidth: "100%" }}

                                                            >
                                                                <div style={{ display: "flex" }}>
                                                                    <div className="topitem-img-div"><img alt="example" src={item.photo_url} className="topitem-img" /></div>
                                                                    <div style={{ marginLeft: "20px" }}><Title level={5}>{item.name}</Title>
                                                                        <Text>{item.description}</Text></div>
                                                                </div>

                                                            </Card>


                                                        </Col>
                                                    )}
                                                </Row>



                                            </Card>
                                        }
                                    </Col>
                                    <Col span={12}>
                                        {salesItem && salesItem.length > 0 &&
                                            <Card title="Top Items based on Sales" className="kpi-card sales-card">


                                                <Row gutter={[16, 48]}>
                                                    {salesItem.map(item =>
                                                        <Col >


                                                            <Card
                                                                hoverable
                                                                style={{ height: "100%", width: 600, maxWidth: "100%" }}

                                                            >
                                                                <div style={{ display: "flex" }}>
                                                                    <div className="topitem-img-div"><img alt="example" src={item.photo_url} className="topitem-img" /></div>
                                                                    <div style={{ marginLeft: "20px" }}><Title level={5}>{item.name}</Title>
                                                                        <Text>{item.description}</Text></div>
                                                                </div>

                                                            </Card>


                                                        </Col>
                                                    )}
                                                </Row>



                                            </Card>
                                        }
                                    </Col>
                                </Row>
                            }




                        </div>
                }
            </Content>
            <R2Footer />
        </Layout>
    )
}

export default Dashboard;
